// Spot transformer Jquery plugin
define('commons/single-selector',['jquery', 'commons/live-search-field'], function($) {
    var pageLoaded = function(data) {
        switch (this.settings.format) {
            case 'json':
                if (this.settings.onDataLoaded !== null){
                    data.headerContainer = this.settings.tapContent + " table.data thead";
                    data.bodyContainer = this.settings.tapContent + " table.data tbody";
                    this.settings.onDataLoaded(data);
                } else {
                    messages.error('An error has occurred with the popup content.');
                }
                break;
            default:
                // HTML By default
                this.tapPopupContent.html(data);
                break;
        }
        this.tapPopupContent.removeClass("loading");
        var changePage = function(event) {
            var page = $(event.currentTarget).data("params");
            var params = page.split("=");
            $.ajax({
                type: 'GET',
                url: this.settings.listUrl,
                data: $.extend({
                    pg: params[1]
                }, this.settings.data()),
                success: pageLoaded,
                context: this
            });
            return false;
        };
        this.tapPopupContent.find(this.settings.linkSelector).each($.proxy(function(index, element) {
            element.href = '#';
            var scope = {
                element: element,
                popup: this.tapPopup,
                targetId: this.targetId,
                params: this.params
            };
            $(element).click($.proxy(this.settings.onIdClick, scope));
        }, this));
        
        this.tapPopupContent.find("a.paginator-link-next").off('click').on('click', $.proxy(changePage, this));
        this.tapPopupContent.find("a.paginator-link-previous").off('click').on('click', $.proxy(changePage, this));
        this.tapPopupContent.find("a.sort-link").off('click').on('click', $.proxy(changePage, this));
        return false;
    };

    var methods = {
        init: function(options) {
            this.settings = $.extend({}, {
                dialogOptions: {
                    'autoOpen': false,
                    'resizable': true,
                    'minWidth': 600,
                    'width': '70%',
                    'height': 450,
                    'zindex': 100,
                    'draggable': true,
                    'dialogClass': 'list-selector-dialog',
                    'modal': true
                },
                format: 'html',
                onDataLoaded: null,
                linkSelector: 'a.id_link',
                filter: {
                    parameter: 'id',
                    placeholder: 'Base station id',
                    label: 'Please select a base station to convert the candidate.'
                },
                refresh: false,
                suffix: '',
                data: function() {
                    return {};
                },
                title: 'Select a Base Station',
                tapContent: false,
                onIdClick: function() {
                }
            }, options);
            this.loaded = false;
            this.id = this.settings.suffix ? '_' + this.settings.suffix : '';
            this.settings.tapContent = this.settings.tapContent ? this.settings.tapContent : '#st_tapcontent' + this.id;
            // Create toolbar
            this.tapPopup = this.first().dialog(this.settings.dialogOptions);
            this.tapPopup.dialog("option", "title", this.settings.title);
            var cont = $(this.tapPopup.dialog("widget").find(".ui-dialog-content"));
            cont.prepend("<div id='st_toolbar' class='toolbar top-fixed'>" + "<span>" + this.settings.filter.label + "</span>" +
                    "<input type='search' incremental='incremental' placeholder='" + this.settings.filter.placeholder + "' id='st_idFilter" + this.id + "' />" + "</div>");
            var listUrl = this.settings.listUrl;
            cont.find("#st_idFilter" + this.id).liveSearch({
                searchUrl: listUrl,
                valueParameter: this.settings.filter.parameter,
                data: $.extend({}, this.settings.data()),
                successCallback: $.proxy(pageLoaded, this)
            });
            cont.append('<div id="st_tapcontent' + this.id + '" class="tapListContent"></div>');
            // get content
            this.tapPopupContent = cont.find(this.settings.tapContent);
            return this;
        },
        open: function(targetId, params) {
            this.targetId = targetId;
            this.params = params;
            this.tapPopup.dialog("open");
            if (!this.loaded || this.settings.refresh) {
                this.loaded = true;
                this.tapPopupContent.addClass("loading");
                $.ajax({
                    type: 'GET',
                    url: this.settings.listUrl,
                    data: $.extend({}, this.settings.data()),
                    success: $.proxy(pageLoaded, this)
                });
            }
        },
        close: function() {
            this.tapPopup.dialog("close");
        },
        setParams: function(params) {
            this.settings.data = function() {
                return params;
            };
        }
    };

    $.fn.singleSelector = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.tooltip');
        }
        return this;
    };

});
